import { Suspense } from "react";
import { Outlet } from "react-router-dom";

const LoadingFallback = () => <div>Loading...</div>;

const SuspenseWrapper = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Outlet />
    </Suspense>
  );
};

export default SuspenseWrapper;
